import { useContext, useMemo } from 'react'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { UserPermissionsContext } from 'app/hooks/useUserPermission'
import { legacyRoleRank } from 'app/types/roles'
import { useUser } from 'app/utils'

/**
 * Hook that returns whether the current user is an org-level user.
 * Reads from context with legacy fallback for staff-v2 OFF.
 */
export function useIsOrgUser(): boolean {
  const user = useUser()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const { permissions, isOrgRole } = useContext(UserPermissionsContext)

  return useMemo(() => {
    // undefined = not loaded or error state = not org user
    if (!user) return false
    // Super users are always org-level (also handled by provider, but safe guard)
    if (user.type === `super`) return true
    // staff-v2 ON + permissions loaded: use context value
    if (staffV2Enabled && permissions !== undefined) {
      return isOrgRole
    }
    // Legacy fallback: check numeric role
    return user.role !== undefined && user.role >= legacyRoleRank.orgUser
  }, [user, user?.type, user?.role, staffV2Enabled, permissions, isOrgRole])
}
